import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

import user from './user'

Vue.use(Vuex)

const strict = process.env.NODE_ENV !== 'production'

const vuexPersist = new VuexPersistence({
  strict,
  storage: window.localStorage,
})

export default new Vuex.Store({
  strict,
  plugins: [vuexPersist.plugin],
  modules: {
    user,
  },
  mutations: {
    RESTORE_MUTATION: vuexPersist.RESTORE_MUTATION,
  },
})
